// standard react component 
import React from 'react';
import '../App.css';
import '../index.css';

function LogTableMarker(props) {
    return (
        <div className="mx-3 my-1 rounded-md">
            <div className="grid grid-cols-5 gap-2 py-2">
                <div className="px-3 font-bold text-gray-500 align-middle flex">
                    {/* time of day */}
                    <div>{props.marker.time}</div>
                </div>
            </div>
        </div>
    );
}

export default LogTableMarker;